import React from "react";
const UploadContext = React.createContext(
  null
);
const UploadContextProvider = ({
  uploadService,
  updateService,
  children
}) => {
  return /* @__PURE__ */ React.createElement(UploadContext.Provider, { value: { uploadService, updateService } }, children);
};
export {
  UploadContext,
  UploadContextProvider
};
//# sourceMappingURL=UploadContext.js.map
